module.exports = __webpack_public_path__ + "img/PT.3e879fb4.webp";